import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalConfig } from './modal.interface';

/**
 * Modal.
 */
@Component({
  selector: 'sg2-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.less']
})
export class ModalComponent {

  /**
   * Constructor.
   *
   * MAT_DIALOG_DATA is injected to access the DialogConfig.data property.
   */
  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly config: ModalConfig,
    public dialogRef: MatDialogRef<ModalComponent>
  ) { }

  /**
   * Close modal.
   *
   * @param action The button clicked to close the modal.
   */
  close(action: string): void {
    this.dialogRef.close(action);
  }

}
